<template>
  <div>
    <PBannerBase height="auto" :inative="false" :isDefault="false" warning>
      <template #title>Atenção</template>
      Esse Webservice é apenas armazenado com as informações da permissão de
      acesso aos arquivos da CIELO. Quando a opção de obter arquivos por data
      estiver disponível, iremos mudar essa informação.
    </PBannerBase>
  </div>
</template>

<script setup lang="ts">
import { PBannerBase } from "@f360-dev/f360-prisma";
</script>
